import { Helmet } from "react-helmet-async";
import { COMPANY } from "../lib/data";

const SITE_URL = "https://www.lebondepanneur.fr";

export default function Seo({ title, description, path = "/", image }) {
  const metaDescription =
    description ||
    "Le Bon Dépanneur : dépannage d'urgence 24/7 en plomberie, serrurerie et électricité à Paris et en Île-de-France. Intervention en 30 minutes, devis clair.";
  const fullTitle = title
    ? `${title} | ${COMPANY.name}`
    : `${COMPANY.name} — Dépannage d'urgence 24/7 · Plomberie, Serrurerie, Électricité`;
  const url = `${SITE_URL}${path}`;
  const ogImage =
    image ||
    "https://images.unsplash.com/photo-1621905251918-48416bd8575a?w=1200&q=80";

  return (
    <Helmet prioritizeSeoTags>
      <title>{fullTitle}</title>
      <meta name="description" content={metaDescription} />
      <link rel="canonical" href={url} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={COMPANY.name} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:locale" content="fr_FR" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={metaDescription} />
      <meta name="twitter:image" content={ogImage} />
    </Helmet>
  );
}
